import React, { Component } from "react";
import PersonalBest from "./PersonalBest";
import $ from 'jquery';

class ParticipantsStats extends Component {
  
  constructor(props) {
		super(props);
		this.state={
			usersArray: []
		}
	}
 
	componentDidMount(){
		var tempUsers = JSON.parse(localStorage.getItem("tempUsers"));
		var participantUsers = [];
		
		for ( var i = 0; i < tempUsers.length; i++ )
			{
				if ( tempUsers[i].hostStatus == 0 ) { participantUsers.push(tempUsers[i]); }
			}
		this.setState({usersArray: participantUsers});
	}
	
	render() {
		return (
			<div className="right_menu_streaming">
				<div className="right_menu_title">Members ({this.props.state.liveParticipantUsers.length})
					<div className="right_close" onClick={() => this.props.updateStateFromChild({rightMenuOpen: false, participantStatsOpen: false})}></div>
				</div>
				{ this.props.state.liveParticipantUsers.sort((a, b) => b.counter - a.counter).map((item, key) => 
					<div className="participant_stat" key={key}>
						<div className="stat_number">{( key == 0 ) ? <img src="./images/trophy-group.svg" alt=""/> : <div>{key+1}</div>}</div>
						<div className="stat_avatar" style={{backgroundImage: "url('" + item.image + "')"}}></div>
						<div className="stat_name">{item.firstName} {item.lastName}</div>
						<div className="holder_result" id={"score"+item.userId+""}>{item.counter}</div>
					</div>
				)}
				<PersonalBest/>
			</div>		
	)}
}

export default ParticipantsStats
